import React from "react";
import { Alert, useTheme } from "@mui/material";

const BANNER_TEXT_COLOR = "#000000";

interface InfoBannerCstProps {
  children: React.ReactNode;
  onClose?: () => void;
  sx?: Record<string, any>;
}

const InfoBannerCst: React.FC<InfoBannerCstProps> = ({
  children,
  onClose,
  sx,
}) => {
  const theme = useTheme();

  return (
    <Alert
      severity="info"
      onClose={onClose}
      sx={{
        borderRadius: "10px",
        padding: "12px",
        alignItems: "center",
        backgroundColor: theme.palette.badge.info.background,
        border: `1px solid ${theme.palette.badge.info.border}`,
        color: BANNER_TEXT_COLOR,
        "& .MuiAlert-icon": {
          padding: 0,
          marginRight: "12px",
          fontSize: "24px",
          opacity: 1,
          color: theme.palette.systemSecondary01,
        },
        "& .MuiAlert-message": { padding: 0, width: "100%" },
        "& .MuiAlert-action .MuiIconButton-root": { color: BANNER_TEXT_COLOR },
        ...sx,
      }}
    >
      {children}
    </Alert>
  );
};

export default InfoBannerCst;
